// extracted by mini-css-extract-plugin
export var danger = "_34-6";
export var lightPink = "_34-a";
export var medium = "_34-j";
export var nearSquare = "_34-m";
export var neutralBlue = "_34-8";
export var neutralYellow = "_34-7";
export var noCapitalize = "_34-1";
export var normal = "_34-2";
export var pill = "_34-0";
export var primary = "_34-3";
export var primaryLight = "_34-4";
export var shadow = "_34-n";
export var small = "_34-k";
export var solidBlack = "_34-i";
export var solidGreen = "_34-d";
export var solidLightBlue = "_34-f";
export var solidNavy = "_34-e";
export var solidOrange = "_34-h";
export var solidPink = "_34-g";
export var solidRed = "_34-b";
export var solidWhite = "_34-9";
export var solidYellow = "_34-c";
export var success = "_34-5";
export var xsmall = "_34-l";